import React, {Component} from 'react';
import classnames from 'classnames';
import './Condition.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTrash, faWrench } from '@fortawesome/free-solid-svg-icons';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import ConditionEdit from './ConditionEdit';

class Condition extends Component {
  
  static defaultProps = {
    conditionText : "UNDEFINED",
    deleteCondition : () => {
      console.error("deleteCondition props is undefined");
    },
    updateCondition : () => {
      console.error("updateCondition props is undefined");
    },
  }

  state = {
    isOnBlur : false,
    isEditMode : false,
  }

  /**
   * onBlur control
   */
  setOnBlurFalse = () => {
    this.setState({
      isOnBlur : false,
    })
  }
  setOnBlurTrue = () => {
    this.setState({
      isOnBlur : true,
    })
  }

  /**
   * 수정모드 Setter
   */
  setIsEditMode = (value) => {
    if (typeof value === "boolean") {
      this.setState({
        isEditMode : value,
      })
    }
  }

  /**
   * 삭제버튼 클릭 핸들러
   */
  handleClickDeleteBtn = (e) => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      this.props.deleteCondition(this.props.conditionId);
    }
  }

  /**
   * 수정버튼 클릭 핸들러
   */
  handleClickEditBtn = (e) => {
    this.setIsEditMode(true);
  }

  /**
   * 컨디션 수정 핸들러
   */
  handleEditConfirm = (editConditionText) => {
    this.props.updateCondition(this.props.conditionId, editConditionText);

    this.setIsEditMode(false);
  }

  render() {
    
    const { setOnBlurFalse } = this;
    const { setOnBlurTrue } = this;
    // const { deleteButtonRender } = this;
    const { conditionText } = this.props;
    const { isOnBlur } = this.state;

    const conditionTextClass = classnames({
      'condition-text' : true,
      'on' : isOnBlur,
      // 'off' : !isOnBlur,
    });

    const deleteButtonRender = (() => {
      const { isOnBlur } = this.state;
      if ( isOnBlur ) {
          
        const editBtnClass = classnames({
          'condition-edit-btn' : true,
          'on' : isOnBlur,
          'off' : !isOnBlur,
        })
        const deleteBtnClass = classnames({
          'condition-btn' : true,
          'on' : isOnBlur,
          'off' : !isOnBlur,
        })
        
        return (
          // <div className="wrapper">
          //   <button class={editBtnClass}>
          //           <FontAwesomeIcon icon={faTrashAlt} />
          //       </button>
          //       <button class={deleteBtnClass}>
          //           <FontAwesomeIcon icon={faTrashAlt} />
          //       </button>
          // </div>
                
          <React.Fragment>
            {/* <button class={editBtnClass}>
              <FontAwesomeIcon icon={faWrench} />
            </button>
            <button class={deleteBtnClass}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </button> */}
          </React.Fragment>
          
        )
      }
    })();

    const conditionClass = classnames({
      "condition" : true,
      "last" : this.props.isLast,
    })

    const btnAreaClass = classnames({
      "btn-area" : true,
      "hide" : !this.state.isOnBlur,
    })

    return (
      <div className={conditionClass}
        onMouseEnter={setOnBlurTrue}
        onMouseLeave={setOnBlurFalse}>
        {
          this.state.isEditMode ? (
            <ConditionEdit 
              conditionText={this.props.conditionText}
              editConfirm={this.handleEditConfirm}
              setIsEditMode={this.setIsEditMode} />
          ) : (
            <React.Fragment>
              <div className={conditionTextClass}>
                {/* <p className="text"> */}
                  {conditionText.trim() !== "" ? conditionText : "컨디션 값이 없습니다"}
                {/* </p> */}
                {deleteButtonRender}
              </div>
              <div className={btnAreaClass}>
                <button className="btn btn-primary edit-btn"
                  onClick={this.handleClickEditBtn} >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button className="btn btn-danger delete-btn"
                  onClick={this.handleClickDeleteBtn} >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

export default Condition;